import styled from "styled-components";

export const Container = styled.div`

    .rbt-input-main{
        border:1px solid #000 !important;
        height: 52px;
        margin-top: 20px;
        width: 100%;
        background-color: #FFFFFF !important;
        color: #000 !important;
        padding: 5px;
        font-weight: 700;
        font-size: 16px;
    }

    .dropdown-menu {
        display: flex !important;
        flex-direction: column !important;
    }

    .dropdown-item {
        background-color: #FFFFFF !important;
        color: #000 !important;
        padding-bottom: 5px !important;
    }

    /* input:nth-child(2){
        margin-top: 70px !important;
        height: 52px;
    } */
`;